import { render, staticRenderFns } from "./HomeQuestion.vue?vue&type=template&id=cbf49da6&scoped=true"
import script from "./HomeQuestion.vue?vue&type=script&lang=js"
export * from "./HomeQuestion.vue?vue&type=script&lang=js"
import style0 from "./HomeQuestion.vue?vue&type=style&index=0&id=cbf49da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf49da6",
  null
  
)

export default component.exports